/**
 * MagnificPopup.js
 */

import $ from 'jquery';
import magnificPopup from '../../../../../node_modules/magnific-popup/dist/jquery.magnific-popup.min.js';

class MagnificPopup {

    constructor() {

        $('.image-popup-vertical-fit').magnificPopup({
            type: 'image',
            closeOnContentClick: true,
            mainClass: 'mfp-img-mobile',
            removalDelay: 300,
            mainClass: 'mfp-fade',
            image: {
                verticalFit: true
            },
            closeMarkup: '<button class="mfp-close"><i class="icon-close icon"></i></button>'
        });


    }

}
new MagnificPopup();